import { Alert, Link, Text, Box } from '@nimbus-ds/components';
import goToAdmin from 'commons/utils/gotToAdmin';
import { useTranslationsMetafields } from 'domains/Metafields/hooks';
import { OwnerResourceType } from 'domains/Metafields/types';

interface UpsellOnAlertCardProps {
  hasInternals: boolean;
  owner: OwnerResourceType;
}

export default function UpsellOnAlertCard({
  hasInternals,
  owner,
}: UpsellOnAlertCardProps) {
  const t = useTranslationsMetafields();
  const handleClick = goToAdmin('/account/plans');

  const alertText = hasInternals
    ? t(`alertMetafieldUpsellOnAlertCard.${owner}.withMetafields.description`)
    : t(
        `alertMetafieldUpsellOnAlertCard.${owner}.withoutMetafields.description`,
      );

  return (
    <Box margin="4">
      <Alert
        appearance="primary"
        title={t(`alertMetafieldUpsellOnAlertCard.${owner}.title`)}
      >
        <Text>{alertText}</Text>
        <Link appearance="primary" textDecoration="none" onClick={handleClick}>
          {t(`alertMetafieldUpsellOnAlertCard.button`)}
        </Link>
      </Alert>
    </Box>
  );
}
